/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParameterTypes } from './ParameterTypes';
import {
    ParameterTypesFromJSON,
    ParameterTypesFromJSONTyped,
    ParameterTypesToJSON,
    ParameterTypesToJSONTyped,
} from './ParameterTypes';

/**
 * 
 * @export
 * @interface ConfigurableParameterDto1
 */
export interface ConfigurableParameterDto1 {
    /**
     * 
     * @type {ParameterTypes}
     * @memberof ConfigurableParameterDto1
     */
    type: ParameterTypes;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConfigurableParameterDto1
     */
    values?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ConfigurableParameterDto1
     */
    unit?: string;
    /**
     * 
     * @type {ConfigurableParameterDto1}
     * @memberof ConfigurableParameterDto1
     */
    parameter?: ConfigurableParameterDto1;
}



/**
 * Check if a given object implements the ConfigurableParameterDto1 interface.
 */
export function instanceOfConfigurableParameterDto1(value: object): value is ConfigurableParameterDto1 {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ConfigurableParameterDto1FromJSON(json: any): ConfigurableParameterDto1 {
    return ConfigurableParameterDto1FromJSONTyped(json, false);
}

export function ConfigurableParameterDto1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurableParameterDto1 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ParameterTypesFromJSON(json['type']),
        'values': json['values'] == null ? undefined : json['values'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'parameter': json['parameter'] == null ? undefined : ConfigurableParameterDto1FromJSON(json['parameter']),
    };
}

export function ConfigurableParameterDto1ToJSON(json: any): ConfigurableParameterDto1 {
    return ConfigurableParameterDto1ToJSONTyped(json, false);
}

export function ConfigurableParameterDto1ToJSONTyped(value?: ConfigurableParameterDto1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ParameterTypesToJSON(value['type']),
        'values': value['values'],
        'unit': value['unit'],
        'parameter': ConfigurableParameterDto1ToJSON(value['parameter']),
    };
}

